// src/components/JoinedFormView.js
import React, { useState } from 'react';
import './JoinedFormView.css';

const JoinedFormView = ({ isOpen, onClose, application, formData, loading }) => {
  if (!isOpen) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    } catch {
      return dateStr;
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content-app form-view-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header-app">
          <div className="modal-header-left">
            <h2><i className="fas fa-file-signature" style={{ color: '#6c63ff' }}></i> Job Application Form</h2>
            <p className="modal-subtitle">
              {application?.candidate_name || 'Candidate'} - {application?.requirement_title || 'Position'}
            </p>
            {formData && (
              <span className={`form-status-badge ${formData.completion_status === 'completed' ? 'status-completed' : formData.completion_status === 'in_progress' ? 'status-in-progress' : 'status-not-started'}`}>
                {formData.completion_status === 'completed' ? '✅ Completed' : 
                 formData.completion_status === 'in_progress' ? '⏳ In Progress' : '⏳ Not Started'}
              </span>
            )}
          </div>
          <button className="modal-close-app" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-body-app">
          {loading ? (
            <div className="form-loading">
              <i className="fas fa-spinner fa-spin"></i>
              <p>Loading form...</p>
            </div>
          ) : formData?.form_data ? (
            <div className="form-view-content">
              {/* Personal Information */}
              <div className="form-section">
                <h4><i className="fas fa-user" style={{ color: '#6c63ff' }}></i> Personal Information</h4>
                <div className="form-view-grid">
                  <div><label>Full Name:</label> <span>{formData.form_data.full_name || 'N/A'}</span></div>
                  <div><label>Father's Name:</label> <span>{formData.form_data.father_name || 'N/A'}</span></div>
                  <div><label>Mobile:</label> <span>{formData.form_data.mobile || 'N/A'}</span></div>
                  <div><label>Emergency Contact:</label> <span>{formData.form_data.emergency_contact || 'N/A'}</span></div>
                  <div><label>Email:</label> <span>{formData.form_data.email || 'N/A'}</span></div>
                  <div><label>Aadhar Number:</label> <span>{formData.form_data.aadhar_number || 'N/A'}</span></div>
                  <div><label>PAN Number:</label> <span>{formData.form_data.pan_number || 'N/A'}</span></div>
                  <div><label>Date of Birth:</label> <span>{formatDate(formData.form_data.dob)}</span></div>
                  <div><label>Place of Birth:</label> <span>{formData.form_data.place_of_birth || 'N/A'}</span></div>
                </div>
              </div>

              {/* Address */}
              <div className="form-section">
                <h4><i className="fas fa-map-marker-alt" style={{ color: '#6c63ff' }}></i> Address</h4>
                <h5>Current Address</h5>
                <div className="form-view-grid">
                  <div><label>Full Address:</label> <span>{formData.form_data.current_address?.full_address || 'N/A'}</span></div>
                  <div><label>Tehsil:</label> <span>{formData.form_data.current_address?.tehsil || 'N/A'}</span></div>
                  <div><label>District:</label> <span>{formData.form_data.current_address?.district || 'N/A'}</span></div>
                  <div><label>State:</label> <span>{formData.form_data.current_address?.state || 'N/A'}</span></div>
                  <div><label>PIN Code:</label> <span>{formData.form_data.current_address?.pin || 'N/A'}</span></div>
                </div>
                {!formData.form_data.permanent_same_as_current && (
                  <>
                    <h5>Permanent Address</h5>
                    <div className="form-view-grid">
                      <div><label>Full Address:</label> <span>{formData.form_data.permanent_address?.full_address || 'N/A'}</span></div>
                      <div><label>Tehsil:</label> <span>{formData.form_data.permanent_address?.tehsil || 'N/A'}</span></div>
                      <div><label>District:</label> <span>{formData.form_data.permanent_address?.district || 'N/A'}</span></div>
                      <div><label>State:</label> <span>{formData.form_data.permanent_address?.state || 'N/A'}</span></div>
                      <div><label>PIN Code:</label> <span>{formData.form_data.permanent_address?.pin || 'N/A'}</span></div>
                    </div>
                  </>
                )}
                {formData.form_data.permanent_same_as_current && (
                  <div className="same-address-note">
                    <i className="fas fa-check-circle" style={{ color: '#28a745' }}></i> Permanent address same as current
                  </div>
                )}
              </div>

              {/* Location & Physical Details */}
              <div className="form-section">
                <h4><i className="fas fa-info-circle" style={{ color: '#6c63ff' }}></i> Location & Physical Details</h4>
                <div className="form-view-grid">
                  <div><label>Location Applying For:</label> <span>{formData.form_data.location_applying_for || 'N/A'}</span></div>
                  <div><label>Identification Mark:</label> <span>{formData.form_data.identification_mark || 'N/A'}</span></div>
                  <div><label>Height:</label> <span>{formData.form_data.height || 'N/A'}</span></div>
                  <div><label>Eye Color:</label> <span>{formData.form_data.eye_color || 'N/A'}</span></div>
                  <div><label>Hair Color:</label> <span>{formData.form_data.hair_color || 'N/A'}</span></div>
                </div>
              </div>

              {/* Education */}
              <div className="form-section">
                <h4><i className="fas fa-graduation-cap" style={{ color: '#6c63ff' }}></i> Education</h4>
                {formData.form_data.education?.map((edu, idx) => (
                  <div key={idx} className="education-view-item">
                    <h5>{edu.qualification}</h5>
                    <div className="form-view-grid">
                      <div><label>Course/Stream:</label> <span>{edu.course_stream || 'N/A'}</span></div>
                      <div><label>Board/University:</label> <span>{edu.board_university || 'N/A'}</span></div>
                      <div><label>Percentage:</label> <span>{edu.percentage || 'N/A'}</span></div>
                      <div><label>Year of Passing:</label> <span>{edu.year_of_passing || 'N/A'}</span></div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Previous Experience */}
              <div className="form-section">
                <h4><i className="fas fa-briefcase" style={{ color: '#6c63ff' }}></i> Previous Experience</h4>
                {formData.form_data.previous_experience?.length > 0 ? (
                  formData.form_data.previous_experience.map((exp, idx) => (
                    <div key={idx} className="experience-view-item">
                      <h5>Experience #{idx + 1}</h5>
                      <div className="form-view-grid">
                        <div><label>Employer Name:</label> <span>{exp.employer_name || 'N/A'}</span></div>
                        <div><label>Designation:</label> <span>{exp.designation || 'N/A'}</span></div>
                        <div><label>Joining Date:</label> <span>{formatDate(exp.joining_date)}</span></div>
                        <div><label>Leaving Date:</label> <span>{formatDate(exp.leaving_date)}</span></div>
                        <div><label>Monthly Salary:</label> <span>{exp.monthly_salary || 'N/A'}</span></div>
                        <div><label>PF/UAN/ESIC No:</label> <span>{exp.pf_uan_esic_no || 'N/A'}</span></div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-experience">No previous experience mentioned</div>
                )}
              </div>   

              {/* Bank Details */}
              <div className="form-section">
                <h4><i className="fas fa-university" style={{ color: '#6c63ff' }}></i> Bank Details</h4>
                <div className="form-view-grid">
                  <div><label>Bank Name:</label> <span>{formData.form_data.bank_details?.bank_name || 'N/A'}</span></div>
                  <div><label>Account Holder Name:</label> <span>{formData.form_data.bank_details?.account_holder_name || 'N/A'}</span></div>
                  <div><label>Account Number:</label> <span>{formData.form_data.bank_details?.account_number || 'N/A'}</span></div>
                  <div><label>IFSC Code:</label> <span>{formData.form_data.bank_details?.ifsc_code || 'N/A'}</span></div>
                  <div><label>Branch Name:</label> <span>{formData.form_data.bank_details?.branch_name || 'N/A'}</span></div>
                </div>
              </div>

              {/* Photo & Signature */}
              <div className="form-section">
                <h4><i className="fas fa-image" style={{ color: '#6c63ff' }}></i> Photo & Signature</h4>
                <div className="form-view-grid">
                  <div>
                    <label>Photo:</label>
                    {formData.photo_url ? (
                      <a href={formData.photo_url} target="_blank" rel="noopener noreferrer" className="file-download-link">
                        <i className="fas fa-file-image"></i> View Photo
                      </a>
                    ) : (
                      <span className="no-file">Not uploaded</span>
                    )}
                  </div>
                  <div>
                    <label>Signature:</label>
                    {formData.signature_url ? (
                      <a href={formData.signature_url} target="_blank" rel="noopener noreferrer" className="file-download-link">
                        <i className="fas fa-file-image"></i> View Signature
                      </a>
                    ) : (
                      <span className="no-file">Not uploaded</span>
                    )}
                  </div>
                </div>
              </div>

              {/* Office Use (Admin only) */}
              {formData.form_data.office_use && (
                <div className="form-section office-use">
                  <h4><i className="fas fa-user-check" style={{ color: '#6c63ff' }}></i> Office Use</h4>
                  <div className="form-view-grid">
                    <div><label>Verified:</label> <span>{formData.form_data.office_use.office_verified ? '✅ Yes' : '❌ No'}</span></div>
                    <div><label>Verified by HR:</label> <span>{formData.form_data.office_use.verified_by_hr_name || 'N/A'}</span></div>
                    <div><label>Verified by Operations:</label> <span>{formData.form_data.office_use.verified_by_ops_name || 'N/A'}</span></div>
                    <div><label>Notes:</label> <span>{formData.form_data.office_use.office_notes || 'N/A'}</span></div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="form-empty">
              <i className="fas fa-file-alt" style={{ fontSize: '40px', color: '#6c757d' }}></i>
              <p>No form data found</p>
              <span>Candidate has not filled the application form yet</span>
            </div>
          )}
        </div>

        <div className="modal-footer-app">
          <button className="btn-close-modal" onClick={onClose}>Close</button>
          {formData?.photo_url && (
            <a href={formData.photo_url} target="_blank" rel="noopener noreferrer" className="btn-download-form">
              <i className="fas fa-download"></i> Download Photo
            </a>
          )}
          {formData?.signature_url && (
            <a href={formData.signature_url} target="_blank" rel="noopener noreferrer" className="btn-download-form">
              <i className="fas fa-download"></i> Download Signature
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default JoinedFormView; 